import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function siteListUpdateRequiredReducer(state = initialState.siteListUpdateRequired, action) {
    switch (action.type) {
        case types.LOAD_SITES_SUCCESS:
        case types.LOAD_SITES_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_SITE_INCOMING:
           case types.UPDATED_SITE_SUCCESS:
            return true;
        default:
            return state;
    }
}